
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState({
            player: (state) => state.player.player,
        }),
    },
}
